<template>
  <div class="container-fluid form">
    <div class="align-items-left">
      <div class="col-md-12 mt-2">
        <div class="back-icon" v-on:click="goTo('select')">
          <fa :icon="['fas', 'arrow-left']" class="h2"/>
        </div>
      </div>
    </div>
    <div class="align-items-center">
      <div class="col-md-12">
        <div class="row justify-content-center mt-2 mb-1">
          <div class="oval-icon rounded-circle d-flex align-items-center mb-3">
            <img src="@/assets/img/users.png" srcset="@/assets/img/users.png" class="mx-auto d-block img-fluid icons">
          </div>
        </div>
        <div class="row justify-content-center mb-3">
          <div class="col-md-12 form-title">
            Formulario Colaboradores
          </div>
        </div>
        <div class="row justify-content-center">
          <b-form @submit.stop.prevent="sendForm" @reset="onReset" class="col-md-12">
            <div class="form-row">
              <div class="form-group col-md-12">
                <b-form-group id="fieldsetEmployeeRut" label="" label-for="employeeRut">
                  <b-form-input id="employeeRut" v-model="$v.form.employeeRut.$model" placeholder="Rut" maxlength="10"
                  :state="validateState('employeeRut')" @focus="setFocusElement('employeeRut')" @blur="setBlurElement('employeeRut')" @keyup="setEmployeeRut" aria-describedby="input-employeeRut" autocomplete="off"></b-form-input>
                  <b-form-invalid-feedback id="input-employeeRut">Campo requerido. Ej: 98765432-1</b-form-invalid-feedback>
                </b-form-group>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <b-form-group id="fieldsetEmployeeName" label="" label-for="employeeName">
                  <b-form-input id="employeeName" v-model="$v.form.employeeName.$model" placeholder="Nombre"
                  :state="validateState('employeeName')" @focus="setFocusElement('employeeName')" @blur="setBlurElement('employeeName')" aria-describedby="input-employeeName" autocomplete="off"></b-form-input>
                  <b-form-invalid-feedback id="input-employeeName">Campo requerido, debe contener ente 3 y 20 caracteres. Ej: Pedro</b-form-invalid-feedback>
                </b-form-group>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <b-form-group id="fieldsetEmployeeLastname" label="" label-for="employeeLastname">
                  <b-form-input id="employeeLastname" v-model="$v.form.employeeLastname.$model" placeholder="Apellido"
                  :state="validateState('employeeLastname')" @focus="setFocusElement('employeeLastname')" @blur="setBlurElement('employeeLastname')" aria-describedby="input-employeeLastname" autocomplete="off"></b-form-input>
                  <b-form-invalid-feedback id="input-employeeLastname">Campo requerido, debe contener ente 3 y 20 caracteres. Ej:Pérez</b-form-invalid-feedback>
                </b-form-group>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <b-form-group id="fieldsetEmployeePhone" label="" label-for="employeePhone">
                  <b-input-group size="md" prepend="(+56)">
                    <b-form-input id="employeePhone" v-model="$v.form.employeePhone.$model" placeholder="Teléfono"
                    :state="validateState('employeePhone')" @focus="setFocusElement('employeePhone')" @blur="setBlurElement('employeePhone')" aria-describedby="input-employeePhone" autocomplete="off"></b-form-input>
                    <b-form-invalid-feedback id="input-employeePhone">Campo requerido, debe contener 9 dígitos. Ej: 995123456</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <b-form-group id="fieldsetEmployeeEmail" label="" label-for="employeeEmail">
                  <b-form-input id="employeeEmail" v-model="$v.form.employeeEmail.$model" placeholder="Email"
                  :state="validateState('employeeEmail')" @focus="setFocusElement('employeeEmail')" @blur="setBlurElement('employeeEmail')" aria-describedby="input-employeeEmail" autocomplete="off"></b-form-input>
                  <b-form-invalid-feedback id="input-employeeEmail">Campo requerido. Ej: nombre@dominio.cl</b-form-invalid-feedback>
                </b-form-group>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <b-form-group id="fieldsetSolutionsSelected" label="" label-for="solutionsSelected">
                  <multiselect id="solutionsSelected" v-model="solutionsSelected" tag-placeholder="Agregar" placeholder="Solución" label="text" track-by="value"
                  :options="solutionsList" :multiple="true" :taggable="true" :hide-selected="true" @tag="addTag"
                  selectLabel="" no-options="" :show-no-results="false" :searchable="false"
                  @input="onChangeSolutions" v-bind:class="['request-solutions', validSolution]"></multiselect>
                  <b-form-input id="employeeSolutions" v-model="$v.form.employeeSolutions.$model" placeholder=""
                  :state="validateState('employeeSolutions')" aria-describedby="input-employeeSolutions" autocomplete="off" v-show="false"></b-form-input>
                  <b-form-invalid-feedback id="input-employeeSolutions">Campo requerido. Debe seleccionar al menos un elemento</b-form-invalid-feedback>
                </b-form-group>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <div id="fieldsetCustomerSelected" label="" label-for="customerSelected">
                  <multiselect id="customerSelected" v-model="customerSelected" tag-placeholder="Razón Social" placeholder="Razón Social" label="customer_name" track-by="customer_id"
                    :options="customersList" open-direction="top" :searchable="true" :loading="isLoading" :internal-search="false" :clear-on-select="false" :close-on-select="true"
                    :options-limit="10" :limit="1" :max-height="400" :show-no-results="true" :hide-selected="true" @search-change="checkName" selectLabel=""
                    v-bind:class="['request-solutions', validName]">
                    <template slot="tag" slot-scope="{ option }"><span class="custom__tag"><span>{{ option.customer_name }}</span></span></template>
                    <template slot="clear" slot-scope="props">
                      <div class="multiselect__clear" v-if="customerSelected.length" @mousedown.prevent.stop="clearAll(props.search)"></div>
                    </template>
                    <span slot="noResult">No encontrado.</span>
                    <span slot="noOptions"></span>
                  </multiselect>
                  <b-form-input id="customerName" v-model="$v.form.customerName.$model" placeholder="Razón Social"
                  :state="validateState('customerName')" aria-describedby="input-customerName" autocomplete="off" v-show="false"></b-form-input>
                  <b-form-invalid-feedback id="input-customerName">Campo requerido. Ej: Entel S.A.</b-form-invalid-feedback>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <b-form-group id="fieldsetCustomerRut" label="" label-for="customerRut">
                  <b-form-input id="customerRut" v-model="$v.form.customerRut.$model" placeholder="Rut de la empresa" maxlength="10"
                  :state="validateState('customerRut')" @focus="setFocusElement('customerRut')" @blur="setBlurElement('customerRut')" @keyup="setCustomerRut" aria-describedby="input-customerRut" autocomplete="off"></b-form-input>
                  <b-form-invalid-feedback id="input-customerRut">{{this.validRutMessage}}</b-form-invalid-feedback>
                </b-form-group>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <b-form-group>
                  <b-form-checkbox-group id="termSelected" v-model="termSelected">
                    <div class="checkbox-group" v-if="termShowed.solution4">
                      <b-form-checkbox value="4">
                        Acepto Condiciones Generales Beneficios Te Conecto.
                      </b-form-checkbox>
                      <span class="anchor" @click="openModalTerm(4)">Ver t&eacute;rminos y condiciones</span>
                    </div>
                    <div class="checkbox-group" v-if="termShowed.solution1">
                      <b-form-checkbox value="1">
                        Acepto Condiciones Medismar - Salud Digital.
                      </b-form-checkbox>
                      <span class="anchor" @click="openModalTerm(1)">Ver t&eacute;rminos y condiciones</span>
                    </div>
                    <div class="checkbox-group" v-if="termShowed.solution2">
                      <b-form-checkbox value="2">
                        Acepto Condiciones Mis Abogados - Ayuda Legal.
                      </b-form-checkbox>
                      <span class="anchor" @click="openModalTerm(2)">Ver t&eacute;rminos y condiciones</span>
                    </div>
                    <div class="checkbox-group" v-if="termShowed.solution3">
                      <b-form-checkbox value="3">
                        Acepto Condiciones BCN - E-Learning.
                      </b-form-checkbox>
                      <span class="anchor" @click="openModalTerm(3)">Ver t&eacute;rminos y condiciones</span>
                    </div>
                  </b-form-checkbox-group>
                  <modalTerm v-model="modalTermOpened" :termId="termId"></modalTerm>
                </b-form-group>
              </div>
            </div>
            <div class="form-row justify-content-center mt-3">
              <vue-recaptcha sitekey="6LeXgLoZAAAAALLroLJ-EGZRy9HQ4XsyN7byQ7Dv" :loadRecaptchaScript="true" @verify="onVerify" @expired="onExpired"></vue-recaptcha>
            </div>
            <b-alert :show="dismissCountDown" dismissible :variant="message.class" @dismissed="dismissCountDown=0" @dismiss-count-down="countDownChanged" class="mt-4">
              <p>{{message.text}}</p>
              <b-progress :variant="message.class" :max="message.seconds" :value="dismissCountDown" height="4px"></b-progress>
            </b-alert>
            <div class="form-row justify-content-center mt-3 mb-3">
              <b-button type="submit" class="btn btn-primary" :disabled="$v.form.$invalid || this.formSend || !this.termChecked || !this.validCaptcha">
                <span class="spinner-border spinner-border-sm" aria-hidden="true" v-if="this.formSend"></span>
                Enviar
              </b-button>
            </div>
          </b-form>
        </div>
      </div>
    </div>
    <div class="align-items-left">
      <div class="col-md-12 mt-2">
        <div class="back-icon" v-on:click="goTo('select')">
          <fa :icon="['fas', 'arrow-left']" class="h2"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import modalTerm from '@/components/ModalTerm.vue'
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength, email } from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],
  components: {
    modalTerm
  },
  props: {
    solution: String
  },
  data () {
    return {
      token: null,
      form: {
        employeeRut: null,
        employeeName: null,
        employeeLastname: null,
        employeePhone: null,
        employeeEmail: null,
        employeeSolutions: null,
        customerId: null,
        customerRut: null,
        customerName: null
      },
      valid: {
        employeeRut: null,
        employeeName: null,
        employeeLastname: null,
        employeePhone: null,
        employeeEmail: null,
        employeeSolutions: null,
        customerRut: null,
        customerName: null
      },
      message: {
        text: '',
        class: '',
        success: 0
      },
      termId: 0,
      modalTermOpened: false,
      dismissCountDown: 0,
      solutionsSelected: [],
      solutionsList: [
        { value: '1', text: 'Salud Digital' },
        { value: '2', text: 'Ayuda Legal' },
        { value: '3', text: 'E-Learning' }
      ],
      termSelected: [],
      termShowed: { solution1: false, solution2: false, solution3: false, solution4: true },
      focusElement: null,
      blurElement: null,
      buttonForm: false,
      buttonCode: false,
      validSolution: null,
      validName: null,
      validCustomerRut: null,
      validCustomerName: null,
      validRutMessage: null,
      customerSelected: [],
      customersList: [],
      isLoading: false,
      formSend: false,
      validCaptcha: false
    }
  },
  mounted () {
    if (this.solution === '1') {
      this.solutionsSelected.push({ value: '1', text: 'Salud Digital' })
    } else if (this.solution === '2') {
      this.solutionsSelected.push({ value: '2', text: 'Ayuda Legal' })
    } else if (this.solution === '3') {
      this.solutionsSelected.push({ value: '3', text: 'E-Learning' })
    }
  },
  validations: {
    form: {
      employeeRut: {
        required,
        minLength: minLength(9),
        maxLength: maxLength(10),
        validateEmail (customerRut) {
          return /[0-9]{7,8}[\\-]{1}[0-9kK]{1}$/.test(customerRut)
        }
      },
      employeeName: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(20),
        validateName (employeeName) {
          return /^([a-zA-ZÁÉÍÓÚñáéíóúÑ\\'\\-]+[\s]?)*$/.test(employeeName)
        }
      },
      employeeLastname: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(20),
        validateName (employeeLastname) {
          return /^([a-zA-ZÁÉÍÓÚñáéíóúÑ\\'\\-]+[\s]?)*$/.test(employeeLastname)
        }
      },
      employeePhone: {
        required,
        minLength: minLength(9),
        maxLength: maxLength(9),
        validatePhone (employeePhone) {
          return /9[0-9]{8}$/.test(employeePhone)
        }
      },
      employeeEmail: {
        required,
        minLength: minLength(9),
        maxLength: maxLength(40),
        email
      },
      employeeSolutions: {
        required
      },
      customerRut: {
        required,
        minLength: minLength(9),
        maxLength: maxLength(10),
        validateEmail (customerRut) {
          return /[0-9]{7,8}[\\-]{1}[0-9kK]{1}$/.test(customerRut)
        }
      },
      customerName: {
        required
      }
    }
  },
  computed: {
    validateForm () {
      return !this.$v.form.$anyError
    },
    termChecked () {
      let response = true
      if (this.termSelected.length > 0) {
        if (this.termShowed.solution1 === true && this.termSelected.indexOf('1') === -1) {
          response = false
        } else if (this.termShowed.solution2 === true && this.termSelected.indexOf('2') === -1) {
          response = false
        } else if (this.termShowed.solution3 === true && this.termSelected.indexOf('3') === -1) {
          response = false
        } else if (this.termSelected.indexOf('4') === -1) {
          response = false
        }
      } else {
        response = false
      }
      return response
    }
  },
  methods: {
    openModalTerm (termId) {
      this.termId = termId
      if (this.modalTermOpened) {
        this.modalTermOpened = false
        setTimeout(() => {
          this.modalTermOpened = true
        }, 1000)
      } else {
        this.modalTermOpened = true
      }
    },
    closeModalTerm () {
      this.modalTermOpened = false
    },
    onChangeSolutions (value) {
      this.setBlurElement('solutionsSelected')
    },
    setFocusElement (focusElement) {
      this.focusElement = focusElement
      if (this.focusElement === 'solutionsSelected') {
        this.focusElement = 'employeeSolutions'
      } else if (this.focusElement === 'customerSelected') {
        this.focusElement = 'customerName'
      }
    },
    setBlurElement (blurElement) {
      this.blurElement = blurElement
      if (this.blurElement === 'solutionsSelected') {
        this.blurElement = 'employeeSolutions'
      } else if (this.blurElement === 'customerRut') {
        this.checkRut()
      } else if (this.blurElement === 'customerSelected') {
        this.blurElement = 'customerName'
      }
    },
    validateState (name) {
      let validated = null
      const { $dirty, $error } = this.$v.form[name]
      if (this.blurElement === name) {
        this.valid[name] = true
      }
      validated = ((this.valid[name] === true) && $dirty) ? !$error : null
      if (name === 'employeeSolutions') {
        if (this.form.employeeSolutions !== null && this.form.employeeSolutions !== '') {
          this.validSolution = 'is-valid'
          validated = true
        } else if (this.form.employeeSolutions !== null) {
          this.validSolution = 'is-invalid'
          validated = false
        }
      } else if (name === 'customerRut') {
        this.validRutMessage = (this.form.customerRut === null || this.form.customerRut === '') ? 'Campo requerido. Ej: 98765432-1' : 'Rut no encontrado. Ej: 98765432-1'
        validated = (validated && this.validCustomerRut)
      } else if (name === 'customerName') {
        if (this.validCustomerName === false) {
          this.validName = 'is-invalid'
          validated = false
        } else if (this.form.customerName !== null && this.form.customerName !== '') {
          this.validName = 'is-valid'
          validated = true
        } else if (this.form.customerName !== null) {
          this.validName = 'is-invalid'
          validated = false
        }
      }
      return validated
    },
    checkRut () {
      this.$http({
        url: 'authenticate',
        method: 'post',
        baseURL: this.$apiUrl,
        data: this.$apiUser
      })
        .then(response => {
          this.token = response.data.token
          let promise = this.$http({
            url: 'requests/customers/?customerRut=' + this.form.customerRut,
            method: 'get',
            baseURL: this.$apiUrl,
            headers: {
              'Authorization': this.token
            },
            data: {}
          })
          return promise.then(
            (resp) => {
              let data = resp.data.data
              if (data.length === 1) {
                this.customerSelected = { 'customer_rut': data[0]['customer_rut'], 'customer_id': data[0]['customer_id'], 'customer_name': data[0]['customer_name'] }
                this.validCustomerRut = true
                this.validCustomerName = true
                this.form.customerId = data[0]['customer_id'].toString()
              } else {
                this.customerSelected = {}
                this.validCustomerRut = false
                this.validCustomerName = false
                this.form.customerId = null
              }
            },
            (error) => {
              console.log(error)
            }
          ).catch(() => {
            console.log('Error')
          })
        },
        (error) => {
          console.log(error)
        })
        .catch(error => {
          console.log(error)
        })
    },
    checkName (query) {
      this.isLoading = true
      this.$http({
        url: 'authenticate',
        method: 'post',
        baseURL: this.$apiUrl,
        data: this.$apiUser
      })
        .then(response => {
          this.token = response.data.token
          let promise = this.$http({
            url: 'requests/customers/?customerName=' + query,
            method: 'get',
            baseURL: this.$apiUrl,
            headers: {
              'Authorization': this.token
            },
            data: {}
          })
          return promise.then(
            (resp) => {
              let data = resp.data.data
              this.customersList = data
              this.isLoading = false
            },
            (error) => {
              console.log('error')
              console.log(error)
            }
          ).catch(() => {
            console.log('Error')
          })
        },
        (error) => {
          console.log(error)
        })
        .catch(error => {
          console.log(error)
        })
    },
    sendForm () {
      let method = 'post'
      let url = 'requests'
      this.buttonForm = true
      this.$v.form.$touch()
      if (!this.$v.form.$anyError && this.validCaptcha) {
        this.formSend = true
        this.$http({
          url: 'authenticate',
          method: method,
          baseURL: this.$apiUrl,
          data: this.$apiUser
        })
          .then(response => {
            this.token = response.data.token
            let data = {}
            data = this.form
            let promise = this.$http({
              url: url,
              method: method,
              baseURL: this.$apiUrl,
              headers: {
                'Authorization': this.token
              },
              data: data
            })
            return promise.then(
              (resp) => {
                let data = resp.data
                this.message.text = (data.data.previous === 1) ? 'Ya realizaste tu solicitud de servicio el ' + this.$moment(String(data.data.requestDate)).format('DD/MM/YYYY hh:mm') : data.message
                this.message.class = (data.data.success === 1) ? 'success' : 'warning'
                this.message.seconds = 5
                this.message.success = data.data.success
                this.showAlert()
                setTimeout(this.buttonActive, 5000)
              },
              (error) => {
                console.log(error)
                this.message.text = 'Disculpe, hubo un error al procesar formulario code[1]'
                this.message.class = 'warning'
                this.message.seconds = 5
                this.message.success = 1
                this.showAlert()
                setTimeout(this.buttonActive, 5000)
              }
            ).catch((error) => {
              console.log(error)
              this.message.text = 'Disculpe, hubo un error al procesar formulario code[2]'
              this.message.class = 'warning'
              this.message.seconds = 5
              this.message.success = 1
              this.showAlert()
              setTimeout(this.buttonActive, 5000)
            })
          },
          (error) => {
            this.message.text = error.message
            this.message.class = 'warning'
            this.message.seconds = 5
            this.message.success = 1
            this.showAlert()
            setTimeout(this.buttonActive, 5000)
          })
          .catch(error => {
            console.log(error)
            this.message.text = 'Disculpe, hubo un error al procesar formulario code[3]'
            this.message.class = 'warning'
            this.message.seconds = 5
            this.message.success = 1
            this.showAlert()
            setTimeout(this.buttonActive, 5000)
          })
      }
    },
    onReset () {
      this.form = {
        employeeRut: null,
        employeeName: null,
        employeeLastname: null,
        employeePhone: null,
        employeeEmail: null,
        employeeSolutions: null,
        customerId: null,
        customerRut: null,
        customerName: null
      }
      this.valid = {
        employeeRut: null,
        employeeName: null,
        employeeLastname: null,
        employeePhone: null,
        employeeEmail: null,
        employeeSolutions: null,
        customerRut: null,
        customerName: null
      }
      this.message = {
        text: '',
        class: '',
        success: 0
      }
      this.dismissCountDown = 0
      this.solutionsSelected = []
      this.solutionsList = [
        { value: '1', text: 'Salud Digital' },
        { value: '2', text: 'Ayuda Legal' },
        { value: '3', text: 'E-Learning' }
      ]
      this.focusElement = null
      this.blurElement = null
      this.buttonForm = false
      this.buttonCode = false
      this.validSolution = null
      this.validName = null
      this.validCustomerRut = null
      this.validCustomerName = null
      this.validRutMessage = null
      this.customerSelected = []
      this.customersList = []
      this.isLoading = false
      this.formSend = false
      this.validCaptcha = false
      if (this.solution === '1') {
        this.solutionsSelected.push({ value: '1', text: 'Salud Digital' })
      } else if (this.solution === '2') {
        this.solutionsSelected.push({ value: '2', text: 'Ayuda Legal' })
      } else if (this.solution === '3') {
        this.solutionsSelected.push({ value: '3', text: 'E-Learning' })
      }
      this.$router.push('/?solution=' + this.solution)
    },
    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.solutionsList.push(tag)
      this.solutionsSelected.push(tag)
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.message.seconds
    },
    buttonActive () {
      this.formSend = false
      if (this.message.success === 1) this.onReset()
    },
    onVerify: function (response) {
      this.validCaptcha = response
    },
    onExpired: function () {
      this.validCaptcha = false
    },
    goTo (template) {
      this.$router.push({ name: template, params: { solution: this.solution }, props: true })
    },
    setEmployeeRut: function () {
      // SI EL CAMPO NO ES NULO
      if (this.form.employeeRut !== null && event.code !== undefined) {
        let lengthHyphen = 2
        this.form.employeeRut = this.form.employeeRut.replace('-', '')
        let strLength = this.form.employeeRut.length
        // SI LA TECLA PULSADA ES NUMERO, K O BACKSPACE
        if (!isNaN(event.key) || event.key === 'k' || event.key === 'K' || event.key === 'Backspace') {
          let kpos = -1
          for (let i = 0; i < strLength; i++) {
            if (this.form.employeeRut[i] === 'k' || this.form.employeeRut[i] === 'K') {
              kpos = i
              break
            }
          }
          if (kpos > 0) {
            this.form.employeeRut = this.form.employeeRut.substring(0, kpos + 1)
          } else if (kpos === 0) {
            this.form.employeeRut = this.form.employeeRut = this.form.employeeRut.substring(0, kpos)
          }
          // SI LA TECLA PULSADA ES LETRA, GUION
        } else if (event.code.indexOf('Key') >= 0 || event.code.indexOf('Digit') >= 0 || event.code === 'NumpadMultiply' || event.code === 'NumpadDivide' || event.code === 'NumpadSubtract' ||
                   event.code === 'NumpadMultiply' || event.code === 'NumpadDecimal' || event.code === 'NumpadAdd' || event.code === 'Comma' || event.code === 'Period' ||
                   event.code === 'Slash' || event.code === 'Quote' || event.code === 'Backslash' || event.code === 'BracketLeft' || event.code === 'BracketRight' ||
                   event.code === 'Equal' || event.code === 'Minus' || event.code === 'IntlBackslash' || event.code === 'Backquote' || event.code === 'Space') {
          strLength = this.form.employeeRut.length
          for (let i = strLength - 1; i >= 0; i--) {
            if (isNaN(this.form.employeeRut[i]) && this.form.employeeRut[i] !== 'k' && this.form.employeeRut[i] !== 'K') {
              this.form.employeeRut = this.form.employeeRut.substring(0, i) + this.form.employeeRut.substring(i + 1)
            }
          }
        }
        if (strLength >= lengthHyphen) {
          this.form.employeeRut = this.form.employeeRut.substring(0, this.form.employeeRut.length - 1) + '-' + this.form.employeeRut.substring(this.form.employeeRut.length - 1)
        }
      }
    },
    setCustomerRut: function () {
      // SI EL CAMPO NO ES NULO
      if (this.form.customerRut !== null && event.code !== undefined) {
        let lengthHyphen = 2
        this.form.customerRut = this.form.customerRut.replace('-', '')
        let strLength = this.form.customerRut.length
        // SI LA TECLA PULSADA ES NUMERO, K O BACKSPACE
        if (!isNaN(event.key) || event.key === 'k' || event.key === 'K' || event.key === 'Backspace') {
          let kpos = -1
          for (let i = 0; i < strLength; i++) {
            if (this.form.customerRut[i] === 'k' || this.form.customerRut[i] === 'K') {
              kpos = i
              break
            }
          }
          if (kpos > 0) {
            this.form.customerRut = this.form.customerRut.substring(0, kpos + 1)
          } else if (kpos === 0) {
            this.form.customerRut = this.form.customerRut = this.form.customerRut.substring(0, kpos)
          }
          // SI LA TECLA PULSADA ES LETRA, GUION
        } else if (event.code.indexOf('Key') >= 0 || event.code.indexOf('Digit') >= 0 || event.code === 'NumpadMultiply' || event.code === 'NumpadDivide' || event.code === 'NumpadSubtract' ||
                   event.code === 'NumpadMultiply' || event.code === 'NumpadDecimal' || event.code === 'NumpadAdd' || event.code === 'Comma' || event.code === 'Period' ||
                   event.code === 'Slash' || event.code === 'Quote' || event.code === 'Backslash' || event.code === 'BracketLeft' || event.code === 'BracketRight' ||
                   event.code === 'Equal' || event.code === 'Minus' || event.code === 'IntlBackslash' || event.code === 'Backquote' || event.code === 'Space') {
          strLength = this.form.customerRut.length
          for (let i = strLength - 1; i >= 0; i--) {
            if (isNaN(this.form.customerRut[i]) && this.form.customerRut[i] !== 'k' && this.form.customerRut[i] !== 'K') {
              this.form.customerRut = this.form.customerRut.substring(0, i) + this.form.customerRut.substring(i + 1)
            }
          }
        }
        if (strLength >= lengthHyphen) {
          this.form.customerRut = this.form.customerRut.substring(0, this.form.customerRut.length - 1) + '-' + this.form.customerRut.substring(this.form.customerRut.length - 1)
        }
      }
    }
  },
  watch: {
    solutionsSelected: function () {
      this.form.employeeSolutions = ''
      let i = 0
      this.termShowed = { solution1: false, solution2: false, solution3: false, solution4: true }
      let tempTermSelected = []
      if (this.solutionsSelected.length > 0) {
        for (i = 0; i < this.solutionsSelected.length; i++) {
          this.form.employeeSolutions += this.solutionsSelected[i]['value'] + ','
          if (this.solutionsSelected[i]['value'] === '1') {
            this.termShowed.solution1 = true
          } else if (this.solutionsSelected[i]['value'] === '2') {
            this.termShowed.solution2 = true
          } else if (this.solutionsSelected[i]['value'] === '3') {
            this.termShowed.solution3 = true
          }
        }
        for (i = 0; i < this.termSelected.length; i++) {
          if (this.termSelected[i] === '1' && this.termShowed.solution1 === true) {
            tempTermSelected.push('1')
          } else if (this.termSelected[i] === '2' && this.termShowed.solution2 === true) {
            tempTermSelected.push('2')
          } else if (this.termSelected[i] === '3' && this.termShowed.solution3 === true) {
            tempTermSelected.push('3')
          } else if (this.termSelected[i] === '4') {
            tempTermSelected.push('4')
          }
        }
        this.termSelected = tempTermSelected
        this.form.employeeSolutions = this.form.employeeSolutions.substring(0, this.form.employeeSolutions.length - 1)
      }
    },
    customerSelected: function () {
      if (this.customerSelected.length === 0) {
        this.form.customerId = null
        this.form.customerRut = null
        this.form.customerName = null
        this.validCustomerRut = null
        this.validCustomerName = null
      } else if (this.customerSelected.customer_id !== undefined && this.customerSelected.customer_id !== null && this.customerSelected.customer_id !== '') {
        this.form.customerId = this.customerSelected.customer_id.toString()
        this.form.customerRut = this.customerSelected.customer_rut
        this.form.customerName = this.customerSelected.customer_name
        this.validCustomerRut = true
        this.validCustomerName = true
      } else {
        this.form.customerId = null
        this.form.customerRut = null
        this.form.customerName = null
        this.validCustomerRut = false
        this.validCustomerName = false
      }
    }
  }
}

</script>
